import type { Distance, SpatialRectangle } from "@pdfking/math"
import { Floor, Scale, Subtract, Total } from "@pdfking/math"
import { MM } from "@pdfking/quantity"
import type { PageShape } from "@pdfking/renderer-api"
import { PlotFunction } from "@pdfking/renderer-api"
import { Range } from "@pdfking/tfunc"

import { PALETTE } from "#constants"

// A dash, the space after it, and their weight
const DASH = MM(2)
const SPACE = MM(1.5)
const STROKE = MM(0.2)

/** A dashed line down the middle of `box`, where a perforation tears it:
 * dashes from its top as many as fit. */
export const DrawPerforation = ({ box }: { box: SpatialRectangle<Distance> }): PageShape[] => {
  const top = Total(box.y, box.height)
  const step = Total(DASH, SPACE)
  const x = Subtract(Total(box.x, Scale(box.width, 0.5)), Scale(STROKE, 0.5))
  return [...Range(Floor(Total(box.height, SPACE) / step))].map(i => ({
    enum: PlotFunction.PLOT_RECT,
    fill_color: PALETTE.lines,
    position: { height: DASH, width: STROKE, x, y: Subtract(top, Total(Scale(step, i), DASH)) },
  }))
}
